import { render, staticRenderFns } from "./QuestionnaireAnswer.vue?vue&type=template&id=5a4399da&"
import script from "./QuestionnaireAnswer.vue?vue&type=script&lang=js&"
export * from "./QuestionnaireAnswer.vue?vue&type=script&lang=js&"
import style0 from "./QuestionnaireAnswer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports